import { useMutation, useQuery } from "convex/react";

import { api } from "@convex/_generated/api";

export function useThreads() {
  const threads = useQuery(api.threads.listForUser);
  const createThread = useMutation(api.threads.create);
  const deleteThread = useMutation(api.threads.deleteThread);
  const updateTitle = useMutation(api.threads.updateTitle);

  return {
    threads,
    createThread,
    deleteThread,
    updateTitle,
    isLoading: threads === undefined,
  };
}
